export default __webpack_public_path__ + "static/media/h_logo.8b588368.svg";